export default __webpack_public_path__ + "static/media/btn-call-on.0d761337.png";